// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6e1023ec","977":"80419466"}[chunkId] + ".chunk.js";
};